import { sendInquirySuccessGAEvent } from "../../analytics";
import VIEW_TYPES from "../../constants/viewTypes";
import mapFormValuesToGraphQLSchema from "../../utilities/mapFormValuesToGraphQLSchema";

const useSellerInquirySubmitHandler = ({
  createInterestedSellerInquiry,
  entityId,
  entityType,
  inquiryType,
  updateView
}) => (formValues, { onError }) => {
  const variables = {
    entityId,
    entityType,
    source: inquiryType,
    ...mapFormValuesToGraphQLSchema(formValues)
  };

  createInterestedSellerInquiry({
    variables
  })
    .then(() => {
      updateView(VIEW_TYPES.success);
      sendInquirySuccessGAEvent(entityType, inquiryType, formValues);
    })
    .catch(onError);
};

export default useSellerInquirySubmitHandler;
